// removed by extract-text-webpack-plugin
module.exports = {"charger-detail-page":"charger-detail-page__3ZZvw","charger-details":"charger-details__24Y_W","info":"info__3f_f0","charger-images":"charger-images__y-_pl","summary":"summary__148v3","details":"details__V9S1e","description":"description__k3HeR"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/views/Charger/styles.scss
// module id = ./app/scripts/views/App/views/Charger/styles.scss
// module chunks = 1